// Sostenibilidad.jsx
import React from 'react';
import {
  PageWrapper,
  HeroSection,
  ContentSection,
  TextBlock,
  StatementHeading,
  FullWidthImage,
  TwoColImages,
} from './PageTemplate';
import ProductBlock from '../../components/ProductBlock';
import SEO from '../../components/SEO';

const IMAGES = {
  fullWidth1: '/images/secciones/Sostenibilidad/Portada_sostenibilidad_reciclar_skincare_physiology_cosmeticos.webp',
  fullWidth2: '/images/secciones/Sostenibilidad/Portada_sostenibilidad_reciclar_skincare_physiology_cosmeticos_2.webp',
  // Imagen del final de la página (antes repetía fullWidth1, la del inicio).
  fullWidth3: '/images/secciones/curated-selection/Imagen_temporal_seccion_3.webp',
  grid: ['/images/secciones/Sostenibilidad/Seccion_web_limpiador_a_la_miel_hidratante_physiology_skincare.webp', '/images/secciones/Sostenibilidad/Seccion_web_limpiadorsalicilico_acti_acne_physiology_skincare.webp'],
};

const PRODUCTS = [
  {
    id: 'sost-prod1',
    title: 'Ultra Barrier Repair',
    description: 'Revitaliza y refuerza nuestra piel a agentes externos',
    price: 800,
    originalPrice: 1200,
    image: 'https://pub-af8345b2339e47c4a9067290386af123.r2.dev/Hydra_Cream_crema_Ultrahidratante_Front_100_Ml-01KW8TDEHHMC3QAAN5ZV5YXA3Y.webp',
    thumbnail: 'https://pub-af8345b2339e47c4a9067290386af123.r2.dev/Hydra_Cream_crema_Ultrahidratante_Front_100_Ml-01KW8TDEHHMC3QAAN5ZV5YXA3Y.webp',
    handle: 'ultra-barrier-repair',
    variants: [{ id: 'v1', title: '60 mL', label: '60 mL', price: 800 }],
    inStock: true,
  },
  {
    id: 'sost-prod2',
    title: 'Kit Minimalista',
    description: 'Este kit contiene todo lo que necesitas',
    price: 2430,
    originalPrice: 2700,
    image: 'https://pub-af8345b2339e47c4a9067290386af123.r2.dev/Kit_minimalista_physiology_skincare_2-01KXKVXS0Q41X4QTS8Q1RACA3V.webp',
    thumbnail: 'https://pub-af8345b2339e47c4a9067290386af123.r2.dev/Kit_minimalista_physiology_skincare_2-01KXKVXS0Q41X4QTS8Q1RACA3V.webp',
    handle: 'kit-minimalista',
    variants: [
      { id: 'v2-natural', title: 'Natural', label: 'Natural', price: 2430 },
      { id: 'v2-pigmento', title: 'Con pigmento', label: 'Con pigmento', price: 2430 },
    ],
    inStock: true,
    badge: 'basic',
  },
];

const Sostenibilidad = () => {
  return (
    <PageWrapper>
      <SEO
        title="Sostenibilidad — Empaque y formulación responsables"
        description="Cómo Physiology Skincare Co reduce su impacto: empaque reciclable, formulación cruelty-free, ingredientes con trazabilidad y procesos de producción responsables."
        path="/sostenibilidad"
      />

      {/* ── Hero ── */}
      <HeroSection
        category="Compromiso ambiental"
        title="Cuidar la piel no puede costarle nada al planeta"
        meta="Tiempo de lectura: 8 min"
      />

      {/* ── Imagen full-width ── */}
      <FullWidthImage src={IMAGES.fullWidth1} alt="Sostenibilidad Physiology" />

      {/* ── Sección 1 ── */}
      <ContentSection narrow>
        <TextBlock
          heading="Envases diseñados para no ser desechados — sino devueltos"
          body="Nuestro programa de retorno de envases permite que cualquier frasco vacío de Physiology sea enviado de vuelta para ser rellenado o reciclado en la cadena correcta. No cobramos por el retorno — lo subsidia nuestra estructura de operación. Los envases primarios están fabricados en vidrio tipo I con tapas de aluminio reciclado."
        />
        <TextBlock
          heading="Fórmulas biodegradables por diseño"
          body="Cada ingrediente de nuestras fórmulas es evaluado no solo por su eficacia en piel sino por su perfil de biodegradabilidad en sistemas acuáticos. Eliminamos filtros UV orgánicos de generación anterior, microplásticos y agentes quelantes de baja degradabilidad. Lo que entra al drenaje no debería quedar ahí."
        />
      </ContentSection>

      {/* ── Statement ── */}
      <ContentSection narrow>
        <StatementHeading text="Lo que es bueno para la piel debe serlo también para el entorno:" />
        <TextBlock
          heading="Cadena de suministro con trazabilidad verificada"
          body="Conocemos el origen de cada ingrediente activo que usamos: el proveedor, el proceso de extracción o síntesis, y las certificaciones de impacto ambiental asociadas. No nos conformamos con un certificado de composición — requerimos documentación de proceso. Esto no es estándar en la industria. Para nosotros, debería serlo."
        />
        <TextBlock
          heading="Sin ingredientes de lista negra, sin excepciones"
          body="Mantenemos una lista interna de 200+ ingredientes que no usaremos bajo ninguna circunstancia, independientemente de su costo, disponibilidad o popularidad en la industria. Incluye compuestos con potencial disruptivo endocrino, tóxicos de acumulación y materias primas con impacto documentado en ecosistemas marinos."
        />
      </ContentSection>

      {/* ── Grid imágenes ── */}
      <ContentSection>
        <TwoColImages images={IMAGES.grid} />
      </ContentSection>

      {/* ── Más texto ── */}
      <ContentSection narrow>
        <TextBlock
          heading="Producción local como decisión de carbono, no solo de orgullo"
          body="Fabricar en México no es únicamente una postura de identidad — reduce drásticamente la huella de carbono logística de nuestros productos. El 90% de nuestro volumen de producción se manufactura a menos de 200 km de nuestro centro de distribución principal. Eso no es casualidad: es diseño de cadena."
        />
        <TextBlock
          heading="Packaging secundario cero en línea permanente"
          body="Ningún producto de nuestra línea permanente incluye caja externa. Lo que ves es lo que hay: el frasco, la etiqueta y el insert de instrucciones en papel certificado FSC. El ahorro de material es significativo en escala — y el producto llega igual de bien protegido."
        />
      </ContentSection>

      {/* ── Imagen full-width ── */}
      <FullWidthImage src={IMAGES.fullWidth2} alt="Proceso sostenible" />

      {/* ── Más texto ── */}
      <ContentSection narrow>
        <TextBlock
          heading="Cruelty-free no es un sello — es una condición de existencia"
          body="No realizamos ni comisionamos pruebas en animales en ninguna etapa de desarrollo. Todos nuestros proveedores de ingredientes activos deben certificar lo mismo. Operamos bajo estándares Leaping Bunny verificados, con auditorías anuales de la cadena de suministro. No vendemos en mercados que exigen pruebas en animales por ley."
        />
        <TextBlock
          heading="Transparencia sobre nuestras limitaciones también"
          body="No somos perfectos. Algunos de nuestros ingredientes técnicamente avanzados todavía requieren síntesis química convencional. Ciertos envases tienen componentes que aún no tienen alternativa de origen reciclado con el mismo desempeño funcional. Lo decimos abiertamente porque la sostenibilidad real se construye con honestidad, no con marketing verde."
        />
      </ContentSection>

      {/* ── Productos relacionados ── */}
      <ProductBlock
        title="Productos relacionados"
        description="Formulados con responsabilidad ambiental"
        buttonText="Ver todos"
        products={PRODUCTS}
      />

      {/* ── Imagen cierre ── */}
      <FullWidthImage src={IMAGES.fullWidth3} alt="Sostenibilidad en acción" />

      {/* ── Cierre ── */}
      <ContentSection narrow>
        <TextBlock
          heading="Metas publicadas, progreso medible"
          body="Para 2026 tenemos como objetivo que el 80% de nuestros envases sean rellenables o de material con al menos 50% de contenido reciclado post-consumo. Publicamos nuestro avance dos veces al año en esta misma sección. Si no lo logramos, lo diremos."
        />
        <TextBlock
          heading="El futuro de la formulación es también el futuro del planeta"
          body="La industria cosmética tiene una responsabilidad ambiental que históricamente ha evadido con sellos genéricos y declaraciones vagas. Nosotros creemos que la forma de cambiar eso es siendo específicos: ingredientes con nombre, concentraciones publicadas, impacto medido. Lo mismo aplica para nuestra relación con el entorno."
        />
      </ContentSection>

    </PageWrapper>
  );
};

export default Sostenibilidad;
